// material-ui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@mui/system/styled';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { collapseDrawerWidth, drawerWidth } from 'store/constant';

const DrawerStyled = styled('div')(({ theme }) => ({
  background: 'white',
  width: collapseDrawerWidth,
  position: 'sticky',
  top: 'calc(80px + var(--safe-area-top))',

  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),

  variants: [
    {
      props: ({ open }) => open,

      style: {
        width: drawerWidth
      }
    }
  ]
}));

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const matchUpLg = useMediaQuery(theme.breakpoints.up('lg'));

  const menuHeight = matchUpMd ? 'calc(var(--safe-area-height) - 88px)' : 'calc(var(--safe-area-height) - 56px)';

  // PerfectScrollbar forces `overflow: hidden` and emulates scrolling in JS, and its touchmove
  // handler always calls preventDefault. That cancels the synthetic click iOS derives from a
  // tap, so any finger jitter eats the press. Touch devices scroll natively instead.
  const drawer = (
    <>
      <BrowserView>
        <PerfectScrollbar component="div" style={{ height: menuHeight, paddingLeft: '16px', paddingRight: '16px', paddingTop: '20px' }}>
          <MenuList />
        </PerfectScrollbar>
      </BrowserView>
      <MobileView>
        <Box sx={{ height: menuHeight, overflowY: 'auto', px: 2 }}>
          <MenuList />
        </Box>
      </MobileView>
    </>
  );

  if (!matchUpLg) {
    return (
      <Drawer
        variant="temporary"
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        ModalProps={{ keepMounted: true }}
        slotProps={{ paper: { sx: { width: drawerWidth, background: 'white', overflow: 'hidden' } } }}
      >
        <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
          <LogoSection />
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 2 }}>
          <MenuList />
        </Box>
      </Drawer>
    );
  }

  return (
    <div>
      <DrawerStyled open={drawerOpen}>{drawer}</DrawerStyled>
    </div>
  );
};

export default Sidebar;
